<div class="dialog">
    <div class="header">
        {{"GENERAL.ALERT" | translate}}
        <div class="ic-close" (click)="close()">
            <i class="icon-cancel"></i>
            <!--    <mat-icon>{{"GENERAL.CLOSE" | translate}}</mat-icon> -->
        </div>
    </div>
    <div class="content" innerHTML="{{itemToDelete}}">

    </div>
    <div class="footer">
        <button id="btnCancel" mat-stroked-button class="btn-tc size-sm btn-secondary-new" [disableRipple]="true"
            appMousePress (click)="close()">{{"GENERAL.CANCEL" | translate}} </button>
        <button mat-flat-button class="btn-tc size-sm btn-primary-new" [disableRipple]="true" appMousePress
            *ngIf="dialogData.type === confirmationType.Confirm" (click)="confirm()">{{"GENERAL.CONFIRM" | translate}}
        </button>
        <button mat-flat-button class="btn-tc size-md btn-primary-new" [disableRipple]="true" appMousePress
            *ngIf="dialogData.type !== confirmationType.Confirm" (click)="confirm()">{{"GENERAL.DELETE" | translate}}
        </button>

    </div>
</div>